<template>
  <div class="editor-wrapper" style="position:relative;">
    <div :id="editorId" style="min-height:350px;"></div>
    <div class="clear-button" style="position:absolute;top:0px;right:10px;width:44px;line-height:44px;">
      <Button size="small" shape="circle" type="warning" @click="clear">清空</Button>
    </div>
  </div>
</template>

<script>
import Editor from 'wangeditor'
import 'wangeditor/release/wangEditor.min.css'
// import { oneOf } from '@/libs/tools'
// import { getToken } from '@/libs/util'
// import { mapActions } from 'vuex'

export default {
  name: 'Editor',
  props: {
    value: {
      type: String,
      default: ''
    },
    /**
     * 绑定的值的类型, enum: ['html', 'text']
     */
    // valueType: {
    //   type: String,
    //   default: 'html',
    //   validator: (val) => {
    //     return oneOf(val, ['html', 'text'])
    //   }
    // },
    /**
     * @description 设置change事件触发时间间隔
     */
    changeInterval: {
      type: Number,
      default: 200
    },
    /**
     * @description 是否开启本地存储
     */
    cache: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    editorId() {
      return `editor${this._uid}`
    }
  },
  methods: {
    // ...mapActions([
    //   'handleLogOut'
    // ]),
    setHtml(val) {
      this.editor.txt.html(val)
    },
    clear() {
      this.editor.txt.clear()
      this.$emit('on-change', '', '')
    }
  },
  // created() {
  //   this.sessionId = getToken()
  // },
  mounted() {
    this.editor = new Editor(`#${this.editorId}`)
    this.editor.customConfig.onchange = (html) => {
      let text = this.editor.txt.text()
      if (this.cache) localStorage.editorCache = html
      this.$emit('input', this.valueType === 'html' ? html : text)
      this.$emit('on-change', html, text)
    }
    this.editor.customConfig.uploadImgShowBase64 = true // 使用 base64 保存图片
    // this.editor.customConfig.pasteFilterStyle = false     // 关闭粘贴样式的过滤
    this.editor.customConfig.onchangeTimeout = this.changeInterval
    this.editor.customConfig.menus = ['head', 'bold', 'fontSize', 'fontName', 'italic', 'underline', 'strikeThrough', 'foreColor', 'backColor', 'justify', 'emoticon', 'table']
    this.editor.customConfig.uploadImgServer = 'https://bjjltong.com/psych/UploadFileController/upload'
    this.editor.customConfig.uploadImgParams = {
      sessionId: this.sessionId
    }
    this.editor.customConfig.uploadFileName = 'uploadFile'
    // this.editor.customConfig.uploadImgHooks = {
    //   success: (xhr, editor, result) => {
    //     if (result.code === 0) {
    //       this.$emit('uploadImgSuccess', result.data)
    //       this.$Notice.success({
    //         title: '图片上传成功'
    //       })
    //     } else if (result.code === 6) {
    //       this.handleLogOut().then(() => {
    //         this.$Notice.warning({
    //           title: '登陆过期，请重新登录'
    //         })
    //         this.$router.push({
    //           name: 'login'
    //         })
    //       })
    //     } else {
    //       this.$Notice.error({
    //         title: result.message,
    //         duration: 2
    //       })
    //     }
    //   },
    //   customInsert: (insertImg, result, editor) => {
    //     insertImg(result.data)
    //   },
    //   error: (xhr, editor) => {
    //     this.$Notice.error({
    //       title: '图片上传时错误',
    //       duration: 2
    //     })
    //   }
    // }
    // create这个方法一定要在所有配置项之后调用
    this.editor.create()
    // 如果本地有存储加载本地存储内容
    // let html = this.value || localStorage.editorCache
    // if (html) this.editor.txt.html(html)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/editor.vue